"use client"

import { useMemo } from "react"
import { normalizeCouponCode } from "src/utilities/coupons"
import { formatPriceLong } from "src/utilities/price"
import { useCartState } from "./useCart"

export type Coupons = {
  codes: string[]
  total: number
  totalFormatted: string
}

function parsePrice(value: string | undefined) {
  if (!value) {
    return 0
  }
  return +value / 100
}

export function useCoupons(): Coupons {
  const { data: cart } = useCartState()

  return useMemo(() => {
    if (!cart) {
      return { codes: [], total: 0, totalFormatted: "" }
    }

    const codes = (cart?.coupons || []).map((coupon) => normalizeCouponCode(coupon.code))
    const total = parsePrice(cart.totals.total_discount) + parsePrice(cart.totals.total_discount_tax)
    const totalFormatted = "-" + formatPriceLong(total)

    return { codes, total, totalFormatted }
  }, [cart])
}
